import { render, staticRenderFns } from "./HistoryItemJob.vue?vue&type=template&id=b52120ee&scoped=true&"
import script from "./HistoryItemJob.vue?vue&type=script&lang=js&"
export * from "./HistoryItemJob.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemJob.vue?vue&type=style&index=0&id=b52120ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52120ee",
  null
  
)

export default component.exports